{
  "pending": "σε εκκρεμότητα"
}
